// src/ui/components/ErrorBoundary.tsx
import { Component, ComponentChildren } from "preact";

interface Props {
    children: ComponentChildren;
    fallback?: ComponentChildren;
}

interface State {
    hasError: boolean;
    error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: any) {
        // Log to error reporting service
        console.error("ErrorBoundary caught an error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                this.props.fallback || (
                    <div role="alert" className="error-boundary">
                        <h2>Something went wrong</h2>
                        <p>
                            Please try refreshing the page. If the problem
                            persists, contact support.
                        </p>
                    </div>
                )
            );
        }

        return this.props.children;
    }
}
